// // src/Redux/thunks/placesThunks.js
// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { axiosGateway } from "../../api/axios";
// import ENDPOINTS from "../../api/endpoints";
// import { BASE_URLS } from "../../api/axios";

// const dbg = (...a) => {
//   if (window.__PLACES_DEBUG__ === false) return;
// };

// /**
//  * GET /places/category/:category
//  * params: { q?, limit?, skip?, governorate?, city?, sort? }
//  */
// export const fetchPlacesByCategory = createAsyncThunk(
//   "places/fetchByCategory",
//   async (
//     { category, q, limit = 50, skip = 0, governorate, city, sort } = {},
//     { rejectWithValue }
//   ) => {
//     try {
//       if (!category) throw new Error("category is required");

//       const url = `${ENDPOINTS.PLACES.LIST_BY_CATEGORY.replace(
//         ":category",
//         encodeURIComponent(String(category))
//       )}`;

//       dbg("GET", url, {
//         q,
//         limit,
//         skip,
//         governorate,
//         city,
//         sort,
//         base: axiosGateway.defaults.baseURL,
//       });

//       const { data } = await axiosGateway.get(url, {
//         params: { q, limit, skip, governorate, city, sort },
//       });

//       const safe = {
//         total: Number(data?.total ?? 0),
//         limit: Number(data?.limit ?? limit),
//         skip: Number(data?.skip ?? skip),
//         items: Array.isArray(data?.items) ? data.items : [],
//       };
//       dbg("fetchByCategory: response", safe);
//       return safe;
//     } catch (err) {
//       dbg("fetchByCategory: ERROR", err);
//       return rejectWithValue(err?.message || "Failed to fetch places");
//     }
//   }
// );

// /**
//  * GET /api/places/details?place_id=...
//  * (facultatif)
//  */
// export const fetchPlaceDetailsById = createAsyncThunk(
//   "places/fetchDetailsById",
//   async ({ place_id } = {}, { rejectWithValue }) => {
//     try {
//       if (!place_id) throw new Error("place_id is required");
//       const { data } = await axiosGateway.get("/api/places/details", {
//         params: { place_id },
//       });
//       dbg("details result", { place_id, data });
//       return data || {};
//     } catch (err) {
//       dbg("details ERROR", err);
//       return rejectWithValue(err?.message || "Failed to fetch place details");
//     }
//   }
// );

// /**
//  * ✅ Helper: construit une URL d’image « safe » (sans passer par Google Place Photo)
//  * - Si l’URL provient de Google Place Photo → on renvoie `null` (le composant affichera son fallback)
//  * - Sinon on renvoie l’URL telle quelle (doit être http/https valide)
//  */
// export const buildPlacePhotoUrl = ({ url, reference } = {}) => {
//   const raw = String(url || "").trim();

//   // 1) Pas d’URL → pas d’image
//   if (!raw) {
//     dbg("buildPlacePhotoUrl: empty url → null");
//     return null;
//   }

//   // 2) Bloquer toute URL Google Place Photo
//   const isGooglePhoto =
//     /(^https?:\/\/)?maps\.googleapis\.com\/maps\/api\/place\/photo/i.test(raw);
//   if (isGooglePhoto) {
//     dbg("buildPlacePhotoUrl: Google Photo blocked → null", { raw });
//     return null; // le front mettra le fallback
//   }

//   // 3) Autoriser seulement http/https classiques
//   if (!(raw.startsWith("http://") || raw.startsWith("https://"))) {
//     dbg("buildPlacePhotoUrl: not http(s) → null", { raw });
//     return null;
//   }

//   // 4) OK
//   dbg("buildPlacePhotoUrl: OK", { final: raw });
//   return raw;
// };


// src/Redux/thunks/placesThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosGateway } from "../../api/axios";
import ENDPOINTS from "../../api/endpoints";
import { BASE_URLS } from "../../api/axios";

const dbg = (...a) => {
  if (window.__PLACES_DEBUG__ === false) return;
};

/**
 * GET /places/category/:category
 * params: { q?, limit?, skip?, governorate?, city?, sort? }
 */
export const fetchPlacesByCategory = createAsyncThunk(
  "places/fetchByCategory",
  async (
    {
      category,
      q,
      limit,       // on va forcer une grosse limite si non fourni
      skip,
      governorate,
      city,
      sort,
    } = {},
    { rejectWithValue }
  ) => {
    try {
      if (!category) throw new Error("category is required");

      const url = `${ENDPOINTS.PLACES.LIST_BY_CATEGORY.replace(
        ":category",
        encodeURIComponent(String(category))
      )}`;

      // 👉 Si aucun limit / skip n’est fourni, on met des valeurs « no limit »
      const effectiveLimit =
        typeof limit === "number" && !Number.isNaN(limit)
          ? limit
          : 99999; // tous les doctors / places
      const effectiveSkip =
        typeof skip === "number" && !Number.isNaN(skip) ? skip : 0;

      dbg("GET", url, {
        q,
        limit: effectiveLimit,
        skip: effectiveSkip,
        governorate,
        city,
        sort,
        base: axiosGateway.defaults.baseURL,
      });

      const { data } = await axiosGateway.get(url, {
        params: {
          q,
          limit: effectiveLimit,
          skip: effectiveSkip,
          governorate,
          city,
          sort,
        },
      });

      const safe = {
        total: Number(data?.total ?? 0),
        limit: Number(data?.limit ?? effectiveLimit),
        skip: Number(data?.skip ?? effectiveSkip),
        items: Array.isArray(data?.items) ? data.items : [],
      };
      dbg("fetchByCategory: response", safe);
      return safe;
    } catch (err) {
      dbg("fetchByCategory: ERROR", err);
      return rejectWithValue(err?.message || "Failed to fetch places");
    }
  }
);

/**
 * GET /api/places/details?place_id=...
 * (facultatif)
 */
export const fetchPlaceDetailsById = createAsyncThunk(
  "places/fetchDetailsById",
  async ({ place_id } = {}, { rejectWithValue }) => {
    try {
      if (!place_id) throw new Error("place_id is required");
      const { data } = await axiosGateway.get("/api/places/details", {
        params: { place_id },
      });
      dbg("details result", { place_id, data });
      return data || {};
    } catch (err) {
      dbg("details ERROR", err);
      return rejectWithValue(err?.message || "Failed to fetch place details");
    }
  }
);

/**
 * ✅ Helper: construit une URL d’image « safe »
 * Maintenant on renvoie simplement l’URL stockée en BD (image_url),
 * sans filtrer Google Place Photo.
 */
export const buildPlacePhotoUrl = ({ url, reference } = {}) => {
  const raw = String(url || "").trim();

  if (!raw) {
    dbg("buildPlacePhotoUrl: empty url → null");
    return null;
  }

  // On accepte directement l’URL telle qu’elle est en BD
  dbg("buildPlacePhotoUrl: return raw URL", { raw });
  return raw;
};
